import { useHistory } from 'react-router-dom/cjs/react-router-dom.min'

export const FormNewButtonBack = ({ text, url }) => {
  const history = useHistory()

  const handleClick = () => (url ? history.push(url) : history.goBack())

  return (
    <button className="btn btn-light border me-1 mt-1" type="button" onClick={handleClick}>
      {text || 'Back'}
    </button>
  )
}
